import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BehaviorSubject, combineLatest, Observable, ObservedValueOf, of, ReplaySubject, Subject, Subscription } from 'rxjs';
import { delay, map, take, takeUntil } from 'rxjs/operators';
import { AssetClassDetailModel, AssetClassLandAreaComponentModel, AssetClassLandAreaModel, AssetClassLandUseModel, AssetClassModel, selectLastCreatedAssetClassDetailId } from 'src/app/core/asset_class';
import { ReadonlyService } from 'src/app/core/_base/crud/utils/readonly.service';
import { Location } from '@angular/common';
import { AuditTrailParticipantModel } from 'src/app/core/assignment';
import { InspectionDetailsComponent } from '../../shared_components/inspection-details/inspection-details.component';
import { LocationData } from 'src/app/core/comparable/_models/location.model';
import { FloorRateModel } from 'src/app/core/asset_class/_models/floor-rate.model';
import { InspectionSizeService } from './inspection-size.service';
import { AssetClassBuildingInformation, AssetClassSizeModel, BuildingDataSource } from 'src/app/core/comparable';
import { InspectionSizeMeasurementsComponent } from './inspection-size-measurements/inspection-size-measurements.component';
import { InspectionPicturesComponent } from './inspection-pictures/inspection-pictures.component';
import { UploadVideoComponent } from '../../shared_components/upload-video/upload-video.component';
import { MapLocationComponent } from '../../shared_components/map-location/map-location.component';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { select, Store } from '@ngrx/store';
import { AppState } from 'src/app/core/reducers';
import { AssetClassDetailOnServerCreated, AssetClassDetailOnServerUpdated } from 'src/app/core/asset_class/_actions/asset-class-detail.actions';
import { InspectionObservationComponent } from './inspection-observation/inspection-observation.component';
import { LinkListComponent } from '../../shared_components/links/link-list/link-list.component';
import { AboutPropertyComponent } from '../../shared_components/about-property/about-property.component';
import { InspectionLandParcelComponent } from './inspection-land-parcel/inspection-land-parcel.component';
import { ServicesAndInfrastructuresComponent } from '../../shared_components/services-and-infrastructures/services-and-infrastructures.component';
import { ExternalAspectsComponent } from '../../shared_components/external-aspects/external-aspects.component';
import { InternalAspectsComponent } from '../../shared_components/internal-aspects/internal-aspects.component';
import { AcGroundsComponent } from '../../shared_components/ac-grounds/ac-grounds.component';
import { currentUser, User } from 'src/app/core/mad-auth/mad-auth.store';
import { BuildingComponent } from '../../shared_components/building/building.component';
import { BuildingSectionComponent } from '../../shared_components/building-section/building-section.component';
import { TabHeader } from '../../shared_components/tab-header/tab-header.component';
import { cloneDeep } from 'lodash';
import { LayoutUtilsService, TypesUtilsService } from 'src/app/core/_base/crud';
import * as _ from 'lodash';
import { InspectionBuildingPicturesComponent } from './inspection-building-pictures/inspection-building-pictures.component';
import { ConditionRatingDataItem, ConditionRatingV2Service } from '../services/condition-rating-v2.service';
import { Rooms } from '../../shared_components/size-module/mongolia-standard-table/mongolia-standard-table.types';
import { InspectionConditionRatingsUploadComponent } from './inspection-condition-ratings-upload/inspection-condition-ratings-upload.component';
import { BuildingFormComponent } from '../../shared_components/building-form/building-form.component';
import { LocationComponent } from '../../shared_components/location/location.component';
import { environment } from 'src/environments/environment';
import { EsgIndicatorsComponent } from '../../mad_shared/esg-indicators/esg-indicators.component';
import { EsgIndicator } from 'src/app/core/v2/state/esg-indicator/type';
import { IPMSPicturesService } from './ipms-pictures.service';
import { PropertyTypes } from 'src/app/core/linked-tables/_models/top-property-type.model';
import { LandMapComponent } from '../../shared_components/land-parcel/land-map/land-map.component';
import { LandUseComponent } from '../../shared_components/land-parcel/land-use/land-use.component';
import { AncillaryBuilding } from 'src/app/core/v3/comparable/special-purpose';
import { AllExternalFacadesRequested, AllMainWallsRequested, AllRoofCoveringsRequested, AllUnitAreaMeasurementsRequested, ExternalFacadeModel, MainWallModel, RoofCoveringModel, selectAllExternalFacades, selectAllMainWalls, selectAllRoofCoverings, selectAllUnitAreaMeasurements, UnitAreaMeasurement } from 'src/app/core/linked-tables';
import { createAncillaryBuilding } from '../../comparable/special-purpose/form/special-purpose-comparable-form.component';
import { createParcelIdentificationFormGroup, ParcelIdentificationFormGroup } from 'src/app/components/parcel-identification/form-group';
import { CoordinatePoint } from 'src/app/core/v3/coordinate-points';
import { LandArea, mapAssetClassLandAreaComponentToLandArea, mapLandAreaToAssetClassLandAreaComponent } from 'src/app/core/v3/land-area';
import { LandAreaFormGroup } from 'src/app/components/land-areas/form-group';

const inspectionTypes = [
  { label: 'Desktop valuation', value: 1, default: true },
  { label: 'External Inspection', value: 2, default: false },
  { label: 'Internal inspection', value: 3, default: false },
  { label: 'Full property survey', value: 4, default: false }
]


@Component({
  selector: 'kt-inspection-base',
  templateUrl: './inspection-base.component.html',
  styleUrls: ['./inspection-base.component.scss'],
  providers: [InspectionSizeService, ConditionRatingV2Service, IPMSPicturesService]
})
export class InspectionBaseComponent implements OnInit, OnDestroy {
  // @ViewChild(InspectionDetailsComponent, {static: false})
  // inspectionDetailComponent: InspectionDetailsComponent;
  @ViewChild(AboutPropertyComponent, { static: false })
  aboutPropertyComponent: AboutPropertyComponent;
  @ViewChild(InspectionSizeMeasurementsComponent, { static: false })
  inspectionSizeMeasurementComponent: InspectionSizeMeasurementsComponent;
  @ViewChild(InspectionObservationComponent, { static: false })
  inspectionObservationComponent: InspectionObservationComponent;
  @ViewChild(InspectionPicturesComponent, { static: false })
  inspectionPicturesComponent: InspectionPicturesComponent;
  @ViewChild(UploadVideoComponent, { static: false })
  uploadVideoComponent: UploadVideoComponent;
  @ViewChild(LinkListComponent, { static: false })
  linkListComponent: LinkListComponent;
  @ViewChild(LocationComponent, { static: false })
  mapLocationComponent: LocationComponent;
  @ViewChild(ServicesAndInfrastructuresComponent, { static: false })
  servicesAndInfraComponent: ServicesAndInfrastructuresComponent;
  @ViewChild(ExternalAspectsComponent, { static: false })
  externalAspectComponent: ExternalAspectsComponent;
  @ViewChild(InternalAspectsComponent, { static: false })
  internalAspectComponent: InternalAspectsComponent;
  @ViewChild(AcGroundsComponent, { static: false })
  acGroundsComponent: AcGroundsComponent;
  @ViewChild(BuildingComponent, { static: false })
  buildingComponent: BuildingComponent;
  @ViewChild(BuildingSectionComponent, { static: false })
  buildingSectionComponent: BuildingSectionComponent;
  @ViewChild(InspectionBuildingPicturesComponent, { static: false })
  buildingPicturesComponent: InspectionBuildingPicturesComponent;
  @ViewChild(InspectionConditionRatingsUploadComponent, { static: false })
  conditionRatingDocumentUploadComponent: InspectionConditionRatingsUploadComponent;
  @ViewChild(BuildingFormComponent, { static: false })
  buildingFormComponent: BuildingFormComponent;
  @ViewChild(EsgIndicatorsComponent, { static: false })
  esgIndicatorComponent: EsgIndicatorsComponent;
  @ViewChild(LandMapComponent)
  landMapComponent: LandMapComponent
  @ViewChild(LandUseComponent, { static: false }) private landUseComponent: LandUseComponent;


  readonly: boolean = false;
  isLoaded: boolean = false;
  hasFormError: boolean = false;
  showConditionRating: boolean = true;
  showBuilding: boolean = false;

  assetClass: AssetClassModel;
  assetClassDetail: AssetClassDetailModel;
  formGroup: UntypedFormGroup;

  // Inspection Details
  agencyName: BehaviorSubject<string> = new BehaviorSubject(null);
  clientName: BehaviorSubject<string> = new BehaviorSubject(null);
  participantsSubject = new BehaviorSubject<AuditTrailParticipantModel[]>([]);
  inspectionDetailData: {
    information_date: string;
    source_of_information: string;
    inspection_date: string;
    time_of_inspection: string;
    duration_of_inspection: string;
    any_limitations_or_restrictions: boolean;
    limitation_desc: string;
    inspection_note: string;
    record_potential_env_issues: boolean;
  }

  // Land parcel
  centerLat = null;
  centerLng = null;

  // Building
  buildingData: BuildingComponent['inputData'];

  // About property
  aboutPropertyData: AboutPropertyComponent['inputData'];
  accommodationData: AboutPropertyComponent['accommodation'];

  // Size and Measurements
  public acSizeInfo: {
    unitAreaMeasurementID: number;
    unitMeasurementID: number;
    measurementStandardID: number;
    standardMeasurementID: number;
    toeUnitOfMeasurementID: number;
  }
  sizesSubject = new BehaviorSubject<AssetClassSizeModel[]>([]);
  acMeasurementData: {
    measurement_date: string;
    unit_measurement_id: number;
    measurement_standard_id: number;
    new_measurement_standard_name: string;
    new_custom_measurement_standard_name: string;
    new_measurement_standard_desc: string;
    new_measurement_standard_files: any[];
    purpose_of_the_measurement_instruction: string;
    measurement_methodology_adopted: string;
    scale_of_plan: string;
    floorpans: string;
    occupiers: string[],
  }
  staticUnit = 2;

  // Condition ratings
  public ratings$: Observable<FloorRateModel[]>;

  // Observation checklist
  public recordPotentialEnvIssue: boolean = false;

  // Picture
  public conditionRatingDropdownValues$: ReplaySubject<{
    key: number,
    value: string,
  }[]>;
  public conditionRatingRelated$: Subject<{
    key: number,
    value: string,
    path: string,
    name: string,
    title: string,
  }>;

  // Video
  videoTitleRequiredError$ = new BehaviorSubject(false);

  private _onDestroy$: Subject<void> = new Subject();
  private componentSubscription: Subscription;
  private saveState: boolean = false;
  currentUser: User;

  private lastTabName = 'Pictures, Videos & others'
  private caTabName = 'Condition Assessment';
  tabHeaders: TabHeader[] = [
    // {label: 'Inspection', disabled: of(false)},
    // {label: 'Location & Building', disabled: of(false)},
    { label: 'Property Information', disabled: of(false) },
    { label: 'ESG indicators', disabled: of(false) },
    { label: this.caTabName, disabled: of(false) },
    { label: this.lastTabName, disabled: of(false) },
  ]
  selectedTab = 0;
  selectedtabchange: BehaviorSubject<number> = new BehaviorSubject(0);
  selectedtabchange$: Observable<number> = this.selectedtabchange.asObservable();
  onTabChange(index: number) {
    this.selectedTab = index;
  }
  onTabChanged(event) {
  }
  error: any = {
    msg: ' Missing Fields in total:',
    fields: []
  }

  public showConditionRating$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  private recordPotentialEnvIssue$: BehaviorSubject<boolean> = new BehaviorSubject(this.recordPotentialEnvIssue);
  public showConditionAssessmentTab: boolean = false;

  building_pictures = [];
  building_picture = null;
  building$ = new BehaviorSubject(null);

  markerInfo: { lat: number, lng: number, isShow: boolean } = { lat: undefined, lng: undefined, isShow: false };
  onMarkerChange(event) {
    if (event == null) {
      return;
    }
    this.markerInfo = {
      lat: event.lat,
      lng: event.lng,
      isShow: event.isShown
    }
  }
  timezoneOffset = '';
  onTimezoneChange(event: string) {
    this.timezoneOffset = event
  }

  public roomChange$ = new BehaviorSubject<Rooms>(null);
  public hasComponents = false;

  agencyId$ = new BehaviorSubject<number>(null);
  toeId$ = new BehaviorSubject<number>(null);
  clientId$ = new BehaviorSubject<number>(null);

  ipmsComponents$ = new BehaviorSubject<any[]>([]);
  private _conditionRatings$ = new BehaviorSubject<any[]>([])
  conditionRatings$ = this._conditionRatings$.asObservable()
  standardMeasurementId = null
  public ipmsConditionRatingDropdownValues$: ReplaySubject<{
    key: number,
    value: string,
  }[]>;
  public ipmsConditionRatingRelated$: Subject<{
    key: number,
    value: string,
    path: string,
    name: string,
    title: string,
  }>;

  // Land
  propertyTypes = PropertyTypes
  private _landLocationData$ = new BehaviorSubject<unknown>(null)
  landLocationData$ = this._landLocationData$.asObservable()
  landUseSubject = new BehaviorSubject<AssetClassLandUseModel>(new AssetClassLandUseModel());
  buildingsSubject = new BehaviorSubject<AssetClassBuildingInformation[]>([])
  landAreaComponentListSubject = new BehaviorSubject<AssetClassLandAreaComponentModel[]>([]);
  landAreaSubject = new BehaviorSubject<AssetClassLandAreaModel>(new AssetClassLandAreaModel());
  private _points$ = new BehaviorSubject<any[]>([])
  points$ = this._points$.asObservable()

  // Form
  private _formState$ = new BehaviorSubject<FormState>({
    location: { invalid: undefined, fields: 0 },
    property: { invalid: undefined, fields: 0 },
    internal_aspect: { invalid: undefined, fields: 0 },
    external_aspect: { invalid: false, fields: 0 },
    grounds: { invalid: undefined, fields: 0 },
    building_pictures: { invalid: undefined, fields: 0 },
    pictures: { invalid: undefined, fields: 0 }
  })
  formTabHeaders$ = this._formState$.asObservable().pipe(
    map(state => {
      return [
        {
          label: 'Location & Building',
          ...locationTab(state)
        },
        {
          label: 'Property Information',
          ...propertyTab(state)
        },
        {
          label: 'ESG Indicators',
          ...esgTab(state)
        },
        {
          label: 'Condition Assessment',
          ...conditionAssessmentTab(state)
        },
        {
          label: 'Pictures, Videos & Others',
          ...picturesTab(state)
        }
      ]
    })
  )
  isSavedBefore: boolean = false

  private _buildings$ = new BehaviorSubject<AncillaryBuilding[]>([])
  buildings$ = this._buildings$.asObservable()
  numberOfBuildings$ = this.buildings$.pipe(map(items => items.length))
  mainwalls: MainWallModel[] = [];
  externalFacades: ExternalFacadeModel[] = [];
  roofCoverings: RoofCoveringModel[] = [];
  unitAreaMeasurements: UnitAreaMeasurement[] = []

  private _coordinatePoints$ = new BehaviorSubject<CoordinatePoint[]>([])
  coordinatePoints$ = this._coordinatePoints$.asObservable()
  private _landAreas$ = new BehaviorSubject<LandArea[]>([])
  landAreas$ = this._landAreas$.asObservable()

  constructor(
    private store: Store<AppState>,
    private activatedRoute: ActivatedRoute,
    private readonlyService: ReadonlyService,
    private location: Location,
    private router: Router,
    private inspectionSizeService: InspectionSizeService,
    public typesUtilsService: TypesUtilsService,
    private formBuilder: UntypedFormBuilder,
    private crV2Service: ConditionRatingV2Service,
    private ipmsPictureService: IPMSPicturesService,
    private layoutUtilService: LayoutUtilsService
  ) { }

  ngOnInit(): void {
    this.readonly = this.readonlyService.isReadOnly();

    const userSubscription = this.store.pipe(
      select(currentUser),
      takeUntil(this._onDestroy$))
      .subscribe(res => {
        if (res) {
          this.currentUser = res;
        }
      });

    this.activatedRoute.params.pipe(takeUntil(this._onDestroy$)).subscribe(params => {
      const id = params.asset_class_id;
      if (id && id > 0) {
        this.activatedRoute.data.pipe(takeUntil(this._onDestroy$)).subscribe(res => {
          this.agencyName.next(res.toeData.data.agency_name);
          this.clientName.next(res.toeData.data.client_name);
          this.agencyId$.next(0);
          this.clientId$.next(res.toeData.data.client_id);
          this.toeId$.next(res.toeData.data.id);

          this.assetClass = res.assetClassData.data as AssetClassModel;
          this.tabHeaders = this._changeTabHeaders(this.tabHeaders);

          if (this.assetClass.type_of_inspection === 3 || this.assetClass.type_of_inspection == 4) {
            const result = this.crV2Service.initializeDropdown();
            this.conditionRatingDropdownValues$ = result.dropdown;
            this.conditionRatingRelated$ = result.related;

            const _result = this.ipmsPictureService.initializeDropdown()
            this.ipmsConditionRatingDropdownValues$ = _result.dropdown
            this.ipmsConditionRatingRelated$ = _result.related
          }

          this.participantsSubject.next(res.subData.participants);

          const _acSize = new AssetClassSizeModel();
          _acSize.standard_measurement_id = this.assetClass.standard_measurement_id;
          _acSize.standard_measurement_name = this.assetClass.standard_measurement_name;
          _acSize.unit_of_area_measurement_id = res.toeData.data.unit_of_measurement_id == 1 ? 2 : 1;
          _acSize.unit_of_area_measurement_name = res.toeData.data.unit_of_measurement_id == 1 ? 'sqft' : 'sqm';
          _acSize.size = this.assetClass.surface;

          if (res.assetClassDet.new) {
            this.assetClassDetail = new AssetClassDetailModel();
            this.assetClassDetail.clear();
            this.assetClassDetail.locationData = {
              ...this.assetClassDetail.locationData,
              latitude: this.assetClass.latitude,
              longitude: this.assetClass.longitude,
              country_id: this.assetClass.country_id,
              city_id: this.assetClass.city_id,
              zip_code: this.assetClass.zip_code,
              address: this.assetClass.address
            }
            this.crV2Service.setConditionRatings([]);
            this.sizesSubject.next([_acSize]);
          } else {
            this.assetClassDetail = Object.assign({}, res.assetClassDet.data) as AssetClassDetailModel;
            this.recordPotentialEnvIssue = this.assetClassDetail.record_potential_env_issues;
            this.recordPotentialEnvIssue$.next(this.recordPotentialEnvIssue);
            this.showConditionRating = !(this.assetClassDetail.sub_type_category_id == 19 || this.assetClassDetail.sub_type_category_id == 21)
            this.showConditionRating$.next(this.showConditionRating);
            this.showBuilding = this.assetClass.type_id == 2 && this.assetClassDetail.sub_type_category_id == 20;

            // this.crService.setRatings(res.subData.ratings);
            this.crV2Service.setConditionRatingsFromRatingModels(res.subData.ratings);
            this.sizesSubject.next(res.subData.sizes);
            if (res.subData.sizes.length < 1) {
              this.sizesSubject.next([_acSize]);
            }
            this.isSavedBefore = true
          }
          this.centerLat = Number(this.assetClassDetail.locationData.latitude)
          this.centerLng = Number(this.assetClassDetail.locationData.longitude)
          this.markerInfo = {
            lat: this.assetClassDetail.locationData.latitude,
            lng: this.assetClassDetail.locationData.longitude,
            isShow: true
          }

          // Land
          this._landLocationData$.next({
            boundary_type_id: this.assetClassDetail.locationData.boundary_type_id ?? 1,
            country_id: this.assetClassDetail.locationData.country_id,
            city_id: this.assetClassDetail.locationData.city_id,
            zip_code: this.assetClassDetail.locationData.zip_code,
            location_grade_id: this.assetClassDetail.locationData.location_grade_id,
            name: this.assetClassDetail.name,
            coordinate_reference_system_id: this.assetClassDetail.land_parcel.coordinate_reference_system_id,
            address: this.assetClassDetail.locationData.address,
            location_surrounding: this.assetClassDetail.locationData.location_surrounding,
            property_type_id: this.assetClass.type_id,
            latitude: this.assetClassDetail.locationData.latitude,
            longitude: this.assetClassDetail.locationData.longitude
          })

          this._coordinatePoints$.next(this.assetClassDetail.points.map(p => ({ latitude: Number(p.lat), longitude: Number(p.lng) })));
          this._landAreas$.next(this.assetClassDetail.landAreaComponents.map(item => mapAssetClassLandAreaComponentToLandArea(item)))
          this._points$.next(this.assetClassDetail.land_parcel.ac_detail_lp_path.map(el => {
            return {
              lat: Number(el.lat),
              lng: Number(el.lng)
            };
          }))
          this.landAreaComponentListSubject.next(this.assetClassDetail.land_parcel.ac_detail_land_area);
          this.landAreaSubject.next(this.assetClassDetail.land_parcel);
          this.landUseSubject.next(this.assetClassDetail.land_parcel);
          this.buildingsSubject.next(Object.assign([], this.assetClassDetail.land_parcel.ac_detail_lp_buildings));

          this.crV2Service.components$.pipe(takeUntil(this._onDestroy$)).subscribe(components => {
            this.hasComponents = components.length > 0;
          })

          this.building_pictures = this.assetClassDetail.building.pictures;
          this.building_picture = this.assetClassDetail.building.picture;

          this.inspectionDetailData = {
            information_date: this.assetClassDetail.information_date,
            source_of_information: this.assetClassDetail.source_of_info,
            inspection_date: this.assetClassDetail.inspection_date,
            time_of_inspection: this.assetClassDetail.time_of_inspection,
            duration_of_inspection: this.assetClassDetail.duration_of_inspection,
            any_limitations_or_restrictions: this.assetClassDetail.any_limitations_or_restrictions,
            limitation_desc: this.assetClassDetail.limitations_desc,
            inspection_note: this.assetClassDetail.inspection_note,
            record_potential_env_issues: this.assetClassDetail.record_potential_env_issues
          }

          this.buildingData = {
            building_id: this.assetClassDetail.building.building_id,
            building_name: this.assetClassDetail.building.building_name,
            building_grade_id: this.assetClassDetail.building.building_grade_id,
            completion_year: this.assetClassDetail.building.completion_year,
            is_part_of_property: this.assetClassDetail.building.is_part_of_property,
            info_about_property: this.assetClassDetail.building.info_about_property,
            building_type: this.assetClassDetail.building.building_type,
            energy_efficiency_grade_id: this.assetClassDetail.building.energy_efficiency_grade_id,
            developer: this.assetClassDetail.building.developer,
            anchor_tenant: this.assetClassDetail.building.anchor_tenant,
            foundation_type_id: this.assetClassDetail.building.foundation_type_id,
            building_type_comment: this.assetClassDetail.building.building_type_comment,
            building_description: this.assetClassDetail.building.building_description,
            pictures: this.assetClassDetail.building.pictures,
            picture: this.assetClassDetail.building.picture
          }
          this._buildings$.next(this.assetClassDetail.ancillary_buildings.map((item: any) => ({ ...item, floors: item.total_floors })))

          this.aboutPropertyData = {
            sub_category_id: this.assetClassDetail.sub_category_id,
            sub_type_category_id: this.assetClassDetail.sub_type_category_id,
            special_purpose_type_id: this.assetClassDetail.aboutProperty.special_purpose_type_id,
            property_grade_id: this.assetClassDetail.aboutProperty.property_grade_id,
            general_desc: this.assetClassDetail.aboutProperty.general_desc,
            completion_year: this.assetClassDetail.aboutProperty.completion_year,
            apprx_year_extended: this.assetClassDetail.aboutProperty.apprx_year_extended,
            state_of_repair_id: this.assetClassDetail.aboutProperty.state_of_repair_id,
            handover_standard_id: this.assetClassDetail.aboutProperty.handover_standard_id,
            foundation_type_id: this.assetClassDetail.aboutProperty.foundation_type_id,
            above_floors: this.assetClassDetail.aboutProperty.above_floors,
            below_floors: this.assetClassDetail.aboutProperty.below_floors,
            construction_desc: this.assetClassDetail.aboutProperty.construction_desc,
            floor_details: this.assetClassDetail.aboutProperty.floor_details ? this.assetClassDetail.aboutProperty.floor_details : this.assetClass.floors_valuated,
            num_of_units: this.assetClassDetail.aboutProperty.num_of_units,
            parking_type_id: this.assetClassDetail.aboutProperty.parking_type_id,
            automation: this.assetClassDetail.aboutProperty.automation,
            automation_type: this.assetClassDetail.aboutProperty.automation_type,
            floor_numbering_scheme_id: this.assetClassDetail.aboutProperty.floor_numbering_scheme_id
              ? this.assetClassDetail.aboutProperty.floor_numbering_scheme_id
              : this.assetClass.floor_numbering_scheme_id,
            developer: this.assetClassDetail.aboutProperty.developer,
            anchor_tenant: this.assetClassDetail.aboutProperty.anchor_tenant,
            has_ancillary_buildings: this.assetClassDetail.aboutProperty.has_ancillary_buildings,
            ancillary_buildings_num: this.assetClassDetail.ancillary_buildings.length
          }

          this.accommodationData = this.assetClassDetail.accommodation

          this.acSizeInfo = {
            unitAreaMeasurementID: this.assetClass.unit_of_area_measurement_id,
            unitMeasurementID: this.assetClassDetail.unit_measurement_id,
            measurementStandardID: this.assetClassDetail.measurement_standard_id,
            standardMeasurementID: this.assetClass.standard_measurement_id,
            toeUnitOfMeasurementID: res.toeData.data.unit_of_measurement_id,
          }
          this.staticUnit = this.acSizeInfo.toeUnitOfMeasurementID;

          this.acMeasurementData = {
            measurement_date: this.assetClassDetail.measurement_date,
            unit_measurement_id: this.assetClassDetail.unit_measurement_id ? this.assetClassDetail.unit_measurement_id : this.assetClass.unit_of_area_measurement_id,
            measurement_standard_id: this.assetClassDetail.measurement_standard_id ? this.assetClassDetail.measurement_standard_id : this.assetClass.standard_measurement_id,
            purpose_of_the_measurement_instruction: this.assetClassDetail.purpose_of_the_measurement_instruction && this.assetClassDetail.purpose_of_the_measurement_instruction.trim() != ''
              ? this.assetClassDetail.purpose_of_the_measurement_instruction
              : this.assetClass.purpose_measurement_name,
            scale_of_plan: this.assetClassDetail.scale_of_plan,
            floorpans: this.assetClassDetail.floorpans,
            measurement_methodology_adopted: this.assetClassDetail.measurement_methodology_adopted && this.assetClassDetail.measurement_methodology_adopted.trim() != ''
              ? this.assetClassDetail.measurement_methodology_adopted
              : this.assetClass.measurement_methodology_name,
            new_measurement_standard_name: this.assetClass.new_standard_measurement_name,
            new_custom_measurement_standard_name: this.assetClassDetail.new_measurement_standard_name ? this.assetClassDetail.new_measurement_standard_name : this.assetClass.new_standard_measurement_name,
            new_measurement_standard_desc: this.assetClassDetail.new_measurement_standard_desc,
            new_measurement_standard_files: this.assetClassDetail.new_measurement_standard_files,
            occupiers: (this.assetClassDetail.occupiers as any[]).map(item => item.name),
          }

          this.isLoaded = true;

          this.formGroup = this.formBuilder.group({
            record_potential_env_issues: [this.assetClassDetail.record_potential_env_issues]
          });
          this.formGroup.addControl('parcel_identification', createParcelIdentificationFormGroup({
            addInfoOnLand: this.assetClassDetail.add_info_on_land,
            boundaryType: this.assetClassDetail.locationData.boundary_type_id,
            landParcelName: this.assetClassDetail.land_parcel_name,
            coordinateReferenceSystemId: this.assetClassDetail.coordinate_reference_system_id,
            landArea: {
              planningStatusId: this.assetClassDetail.landArea.planning_status_id,
              qosDegradationId: this.assetClassDetail.landArea.qos_degradation_id,
              envConsiderations: this.assetClassDetail.landArea.env_considerations,
              otherConsiderations: this.assetClassDetail.landArea.other_considerations,
              // TODO
              zoning_file_name: null,
              zoning_file_path: null,
              zoning_comment: null,
              heritage_file_name: null,
              heritage_file_path: null,
              heritage_comment: null
            }
          }));
          this.formGroup.controls.record_potential_env_issues.valueChanges.pipe(
            takeUntil(this._onDestroy$)
          ).subscribe(val => {
            this.recordPotentialEnvIssue = val;
          })

          this._updateState()
        });
      }
    })

    combineLatest([
      this.ipmsComponents$,
      this._conditionRatings$
    ]).pipe(
      takeUntil(this._onDestroy$)
    ).subscribe(([components, ratings]) => {
      this.ipmsPictureService.setRatings(ratings, components)
    })

    this.store.dispatch(new AllMainWallsRequested());
    this.store.select(selectAllMainWalls).pipe(takeUntil(this._onDestroy$)).subscribe(res => {
      this.mainwalls = res ? res.filter(item => item.property_sub_type_id == 0) : []
    });

    this.store.dispatch(new AllExternalFacadesRequested());
    this.store.select(selectAllExternalFacades).pipe(takeUntil(this._onDestroy$)).subscribe(res => {
      this.externalFacades = res ? res.filter(item => item.property_sub_type_id == 0) : []
    })

    this.store.dispatch(new AllRoofCoveringsRequested());
    this.store.select(selectAllRoofCoverings).pipe(takeUntil(this._onDestroy$)).subscribe(res => {
      this.roofCoverings = res ? res.filter(item => item.property_sub_type_id == 0) : []
    });

    this.store.dispatch(new AllUnitAreaMeasurementsRequested())
    this.store.select(selectAllUnitAreaMeasurements).pipe(takeUntil(this._onDestroy$)).subscribe(res => {
      this.unitAreaMeasurements = res ? res : []
    })
  }

  private _changeTabHeaders(ths: TabHeader[]): TabHeader[] {
    const tabheaders = cloneDeep(ths);
    let title = 'Location & Building';
    if (this.assetClass.type_id == 17 || this.assetClass.type_id == 11 || this.assetClass.type_id == 2 || this.assetClass.type_id == 7) {
      title = 'Location & Land Identification';
    }
    tabheaders.splice(0, 0, { label: title, disabled: of(false) });
    return tabheaders;
  }

  ngOnDestroy(): void {
    this._onDestroy$.next();
    this._onDestroy$.complete();
    if (this.componentSubscription) {
      this.componentSubscription.unsubscribe();
    }
  }

  getComponentTitle(): string {
    if (!this.assetClass) {
      return '';
    }
    if (this.assetClass.type_of_inspection > 0) {
      return `Property Sub-Type ${this.assetClass.type_name} - ${inspectionTypes[this.assetClass.type_of_inspection - 1].label} Details for "${this.assetClass.name}" ${this.readonly ? '(READ ONLY)' : ''}`;
    }
    return `Property Sub-Type ${this.assetClass.type_name} Details ${this.readonly ? '(READ ONLY)' : ''}`;
  }

  back() {
    this.location.back();
  }

  onStaticUnitChange(staticUnit: number) {
    this.staticUnit = staticUnit;
  }

  onSubmit(isComplete: boolean = true) {
    let errorFields = [];
    this.hasFormError = false;
    this.videoTitleRequiredError$.next(false);
    let formState = this._formState$.getValue()

    // Inspection Detail section
    // if (this.inspectionDetailComponent) {
    //   if (isComplete && !this.inspectionDetailComponent.checkValidation(isComplete)) {
    //     this.hasFormError = true;
    //     errorFields = [...errorFields, ...this.inspectionDetailComponent.errorFields];
    //   }
    // }
    // Map Location
    formState = { ...formState, location: { invalid: false, fields: 0 } }
    if (this.mapLocationComponent) {
      if (isComplete && this.mapLocationComponent.validate()) {
        this.hasFormError = true;
        errorFields = [...errorFields, ...this.mapLocationComponent.errorFields];
        formState = { ...formState, location: { invalid: true, fields: formState.location.fields + this.mapLocationComponent.errorFields.length } }
      }
    }
    if (this.landMapComponent) {
      if (isComplete && !this.landMapComponent.isValid(isComplete)) {
        this.hasFormError = true;
        errorFields = [...errorFields, ...this.landMapComponent.getErrorField()]
        formState = { ...formState, location: { invalid: true, fields: formState.location.fields + this.landMapComponent.getErrorField().length } }
      }
    }

    // Land parcel
    // if (this.inspectionLandParcelComponent) {
    //   if (isComplete && !this.inspectionLandParcelComponent.checkValidation(isComplete)) {
    //     this.hasFormError = true;
    //     errorFields = [...errorFields, ...this.inspectionLandParcelComponent.errorFields];
    //   }
    // }

    // External aspects
    formState = { ...formState, external_aspect: { invalid: false, fields: 0 } }
    if (this.externalAspectComponent) {
      if (isComplete && this.externalAspectComponent.validate()) {
        this.hasFormError = true;
        errorFields = [...errorFields, ...this.externalAspectComponent.errorFields];
        formState = { ...formState, external_aspect: { invalid: true, fields: formState.external_aspect.fields + this.externalAspectComponent.errorFields.length } }
      }
    }

    formState = { ...formState, internal_aspect: { invalid: false, fields: 0 } }
    // Internal aspects
    if (this.internalAspectComponent) {
      if (isComplete && this.internalAspectComponent.validate()) {
        this.hasFormError = true;
        errorFields = [...errorFields, ...this.internalAspectComponent.errorFields];
        formState = { ...formState, internal_aspect: { invalid: true, fields: formState.internal_aspect.fields + this.internalAspectComponent.errorFields.length } }
      }
    }
    // Grounds
    formState = { ...formState, grounds: { invalid: false, fields: 0 } }
    if (this.acGroundsComponent) {
      if (isComplete && this.acGroundsComponent.validate()) {
        this.hasFormError = true;
        errorFields = [...errorFields, ...this.acGroundsComponent.errorFields];
        formState = { ...formState, grounds: { invalid: true, fields: formState.grounds.fields + this.acGroundsComponent.errorFields.length } }
      }
    }

    // Building
    if (this.buildingComponent) {
      if (isComplete && !this.buildingComponent.checkValidation(isComplete)) {
        this.hasFormError = true;
        errorFields = [...errorFields, ...this.buildingComponent.errorFields];
      }
    }

    if (this.buildingSectionComponent) {
      if (isComplete && this.buildingSectionComponent.validate()) {
        this.hasFormError = true
        errorFields = [...errorFields, ...this.buildingSectionComponent.errorFields];
      }
    }
    if (this.buildingFormComponent) {
      if (isComplete && this.buildingFormComponent.validate()) {
        this.hasFormError = true;
        errorFields = [...errorFields, ...this.buildingFormComponent.errorFields.map(f => 'building_form_' + f)];
      }
    }

    // About property
    formState = { ...formState, property: { invalid: false, fields: 0 } }
    if (this.aboutPropertyComponent) {
      if (isComplete && !this.aboutPropertyComponent.checkValidation(isComplete)) {
        this.hasFormError = true;
        errorFields = [...errorFields, ...this.aboutPropertyComponent.errorFields];
        formState = { ...formState, property: { invalid: true, fields: formState.property.fields + this.aboutPropertyComponent.errorFields.length } }
      }
    }


    // Size and measurements
    if (this.inspectionSizeMeasurementComponent) {
      if (isComplete && !this.inspectionSizeMeasurementComponent.checkValidation(isComplete)) {
        this.hasFormError = true;
        errorFields = [...errorFields, ...this.inspectionSizeMeasurementComponent.errorFields];
      }
    }

    // Condition ratings

    // Pictures
    formState = { ...formState, pictures: { invalid: false, fields: 0 } }
    if (this.inspectionPicturesComponent) {
      if (isComplete && !this.inspectionPicturesComponent.checkValidation(isComplete)) {
        this.hasFormError = true;
        errorFields = [...errorFields, ...this.inspectionPicturesComponent.errorFields];
        formState = { ...formState, pictures: { invalid: true, fields: formState.pictures.fields + this.inspectionPicturesComponent.errorFields.length } }
      }
    }

    if (this.buildingPicturesComponent) {
      if (isComplete && !this.buildingPicturesComponent.checkValidation(isComplete)) {
        this.hasFormError = true;
        errorFields = [...errorFields, ...this.buildingPicturesComponent.errorFields];
        formState = { ...formState, building_pictures: { invalid: true, fields: formState.building_pictures.fields + this.buildingPicturesComponent.errorFields.length } }
      }
    }

    // Videos
    let videoTitleRequired = false;
    if (isComplete && this.uploadVideoComponent) {
      const videos = this.uploadVideoComponent.uploadedVideos;
      videos.forEach(video => {
        if (video.title === null || video.title === '') {
          this.hasFormError = true;
          videoTitleRequired = true;
        }
      })
    }
    this.videoTitleRequiredError$.next(videoTitleRequired);

    // Matterport link

    // Condition Rating Documents
    if (this.conditionRatingDocumentUploadComponent) {
      if (isComplete && !this.hasComponents && !this.conditionRatingDocumentUploadComponent.checkValidation(isComplete)) {
        this.hasFormError = true;
        errorFields = [...errorFields, ...this.conditionRatingDocumentUploadComponent.errorFields];
      }
    }

    let esgIndicatorValues: EsgIndicator | null = null
    if (this.esgIndicatorComponent) {
      const esgIndicatorResult = this.esgIndicatorComponent.submit(!isComplete)
      if (esgIndicatorResult.type === 'success') {
        esgIndicatorValues = esgIndicatorResult.values
      } else if (esgIndicatorResult.type === 'error') {
        this.hasFormError = true
        errorFields = [...errorFields, esgIndicatorResult.errors]
      }
    }
    this.landMapComponent && this.landMapComponent.updateValue(isComplete)
    this.landUseComponent && this.landUseComponent.updateValue(isComplete);

    this._formState$.next(formState)
    if (this.hasFormError) {
      this.error.fields = errorFields;
      this.layoutUtilService.showFormError()
      return;
    }

    const { ac, ..._acData } = this._prepareAssetClassDetail(isComplete, esgIndicatorValues);

    if (ac.id) {
      this.updateAssetClassDetail(ac, _acData);
    } else {
      this.createAssetClassDetail(ac, _acData);
    }
  }

  onRecordPotentialChange(event: boolean) {
    this.recordPotentialEnvIssue = event;
    this.recordPotentialEnvIssue$.next(this.recordPotentialEnvIssue);
  }

  onFloorChanged(event: { floors: number[], scheme_id: number }) {
    this.crV2Service.floorChanged(event);
    this.inspectionSizeService.setFloor(event);

    this._setConditionRatingByFloor(event)
  }

  private _setConditionRatingByFloor(
    event: { floors: number[], scheme_id: number }
  ) {
    const currentRatings = this._conditionRatings$.value
    const newRatings = event.floors.map(floor => {
      const rating = currentRatings.find(item => item.floor.number === floor)
      if (!rating) {
        return {
          floor: {
            schemeId: event.scheme_id,
            number: floor
          }
        }
      }
      return rating
    })
    this._conditionRatings$.next(newRatings)
  }

  onChangeConditionRatings(values: any[]) {
    this._conditionRatings$.next(values)
  }

  private _prepareAssetClassDetail(isComplete: boolean, esgIndicator: EsgIndicator): {
    ac: AssetClassDetailModel,
    sizes: AssetClassSizeModel[],
    fileList: any[],
    selectedFacilities: any[],
    selectedFacilitiesOffice: any[],
    selectedFacilitiesOfficeExclusive: any[],
    externalAreas: any[],
    ratings: FloorRateModel[],
    participants: AuditTrailParticipantModel[],
    userId: number,
    sizeModuleData: any,
    ipmsSizeData: any,
    codeOfMeasurementData: any
  } {
    let sizes = [];
    let fileList = [];
    let ratings = [];
    let participants = [];
    let sizeModuleData = null;
    let ipmsSizeData = null;
    let codeOfMeasurementData = null;
    const _acDetail = new AssetClassDetailModel();
    _acDetail.clear();
    _acDetail.id = this.assetClassDetail.id;
    _acDetail.is_complete = Number(isComplete);
    _acDetail.tp_id = this.assetClass.id;
    _acDetail.user_id = this.currentUser.id;
    _acDetail.esgIndicator = esgIndicator


    const controls = this.formGroup.controls;
    // 
    // Inspection Details
    // if (this.inspectionDetailComponent) {
    //   const data = this.inspectionDetailComponent.getData();
    //   _acDetail.information_date = data.information_date;
    //   _acDetail.source_of_info = data.source_of_information;
    //   _acDetail.inspection_date = data.inspection_date;
    //   _acDetail.time_of_inspection = data.time_of_inspection;
    //   _acDetail.duration_of_inspection = data.duration_of_inspection;
    //   _acDetail.any_limitations_or_restrictions = data.any_limitations_or_restrictions;
    //   _acDetail.limitations_desc = data.limitation_desc;
    //   _acDetail.inspection_note = data.inspection_note;
    //   _acDetail.record_potential_env_issues = this.formGroup.controls.record_potential_env_issues.value;

    //   participants = this.inspectionDetailComponent.getParticipants();
    // }

    _acDetail.record_potential_env_issues = this.formGroup.controls.record_potential_env_issues.value;
    if (this.mapLocationComponent) {
      _acDetail.locationData = this.mapLocationComponent.getData();
    }

    const parcelIdentificationForm = controls.parcel_identification as ParcelIdentificationFormGroup
    const landAreaForm = parcelIdentificationForm.controls.land_area as LandAreaFormGroup
    const landArea = new AssetClassLandAreaModel()
    landArea.clear()
    landArea.id = this.assetClassDetail.landArea.id
    landArea.planning_status_id = landAreaForm.controls.planning_status_id.value
    landArea.qos_degradation_id = landAreaForm.controls.qos_degradation_id.value
    landArea.env_considerations = landAreaForm.controls.env_considerations.value
    landArea.other_considerations = landAreaForm.controls.other_considerations.value
    _acDetail.add_info_on_land = parcelIdentificationForm.controls.add_info_on_land.value;
    _acDetail.land_parcel_name = parcelIdentificationForm.controls.land_parcel_name.value;
    _acDetail.coordinate_reference_system_id = parcelIdentificationForm.controls.coordinate_reference_system_id.value;
    _acDetail.landArea = landArea;
    _acDetail.points = this._coordinatePoints$.value.map(item => ({ lat: item.latitude, lng: item.longitude }));
    _acDetail.landAreaComponents = this._landAreas$.value.map(item => mapLandAreaToAssetClassLandAreaComponent(item))
    _acDetail.locationData.boundary_type_id = parcelIdentificationForm.controls.boundary_type.value

    if (this.buildingComponent) {
      _acDetail.building = {
        ...this.buildingComponent.getData(),
        id: this.assetClassDetail.building.id,
        building_id: null,
        pictures: [],
        picture: null
      };
    }

    if (this.buildingSectionComponent) {
      _acDetail.building = {
        ...this.buildingSectionComponent.getDataForComparable(),
        id: this.assetClassDetail.building.id,
      }
    }
    if (this.buildingFormComponent) {
      _acDetail.buildingInfo = {
        ...this.buildingFormComponent.getData(),
        id: this.assetClassDetail.buildingInfo.id
      };
    }

    if (this.aboutPropertyComponent) {
      const data = this.aboutPropertyComponent.getData();
      _acDetail.accommodation = data.accommodation;
      _acDetail.aboutProperty = {
        id: this.assetClassDetail.aboutProperty.id,
        property_grade_id: data.about.property_grade_id,
        general_desc: data.about.general_desc,
        completion_year: data.about.completion_year,
        apprx_year_extended: data.about.apprx_year_extended,
        state_of_repair_id: data.about.state_of_repair_id,
        handover_standard_id: data.about.handover_standard_id,
        foundation_type_id: data.about.foundation_type_id,
        above_floors: data.about.above_floors,
        below_floors: data.about.below_floors,
        construction_desc: data.about.construction_desc,
        floor_details: data.about.floor_details,
        num_of_units: data.about.num_of_units,
        parking_type_id: data.about.parking_type_id,
        automation: data.about.automation,
        automation_type: data.about.automation_type,
        floor_numbering_scheme_id: data.about.floor_numbering_scheme_id,
        special_purpose_type_id: data.about.special_purpose_type_id,
        developer: data.about.developer,
        anchor_tenant: data.about.anchor_tenant,
        has_ancillary_buildings: data.about.has_ancillary_buildings
      }
      _acDetail.sub_type_category_id = data.about.sub_type_category_id;
      _acDetail.sub_category_id = data.about.sub_category_id;
    }

    if (this.servicesAndInfraComponent) {
      _acDetail.serviceAndInfraData = this.servicesAndInfraComponent.getdata();
    }

    if (this.externalAspectComponent) {
      _acDetail.externalAspectData = this.externalAspectComponent.getData();
    }

    if (this.internalAspectComponent) {
      _acDetail.internalAspectData = this.internalAspectComponent.getData();
    }

    if (this.acGroundsComponent) {
      _acDetail.grounds = { ...this.acGroundsComponent.getData(), id: this.assetClassDetail.grounds.id };
    }

    // Sizes and measurements
    if (this.inspectionSizeMeasurementComponent) {
      const data = this.inspectionSizeMeasurementComponent.getData();
      _acDetail.measurement_date = data.measurement_date;
      _acDetail.measurement_methodology_adopted = data.measurement_methodology_adopted;
      _acDetail.scale_of_plan = data.scale_of_plan;
      _acDetail.floorpans = data.floorpans;
      _acDetail.purpose_of_the_measurement_instruction = data.purpose_of_the_measurement_instruction;
      _acDetail.unit_measurement_id = data.unit_measurement_id;
      _acDetail.measurement_standard_id = data.measurement_standard_id;
      _acDetail.new_measurement_standard_name = data.new_measurement_standard_name;
      _acDetail.new_measurement_standard_desc = data.new_measurement_standard_desc;
      _acDetail.new_measurement_standard_files = data.new_measurement_standard_files;
      _acDetail.new_custom_measurement_standard_name = data.new_custom_measurement_standard_name;
      _acDetail.occupiers = data.occupiers

      sizeModuleData = this.inspectionSizeMeasurementComponent.getSizeModuleData();
      ipmsSizeData = this.inspectionSizeMeasurementComponent.getIPMSizeData()
      codeOfMeasurementData = this.inspectionSizeMeasurementComponent.getCodeOfMeasurementData()
      sizes = this.sizesSubject.value;
    }

    // Condition Ratings
    ratings = this.crV2Service.getRatings();

    // Observation
    if (this.inspectionObservationComponent) {
      const data = this.inspectionObservationComponent.getData();
      _acDetail.record_info_type = data.record_info_type;
      _acDetail.observation_checklist = data.checkList;
      _acDetail.observation_documents = data.documents;
    }

    // Pictures
    if (this.inspectionPicturesComponent) {
      const data = this.inspectionPicturesComponent.getData();
      _acDetail.picture = data.picture;
      fileList = data.pictures;
    }

    if (this.buildingPicturesComponent) {
      const data = this.buildingPicturesComponent.getData();
      _acDetail.building.picture = data.picture;
      _acDetail.building.pictures = data.pictures;
    }

    // Videos
    if (this.uploadVideoComponent) {
      _acDetail.videos = this.uploadVideoComponent.uploadedVideos;
    }

    // Link
    if (this.linkListComponent) {
      _acDetail.links = this.linkListComponent.links;
    }

    // Condition Rating Documents
    if (this.conditionRatingDocumentUploadComponent) {
      _acDetail.condition_rating_documents = this.conditionRatingDocumentUploadComponent.getDocuments();
    }

    // Land
    _acDetail.land_parcel.ac_detail_lp_path = this.landMapComponent ? this.landMapComponent.getPath() : []
    if (this.landMapComponent) {
      const result = this.landMapComponent.getData()
      _acDetail.locationData = result
      _acDetail.name = result.name;
      _acDetail.land_parcel.coordinate_reference_system_id = result.coordinate_reference_system_id ?? null;
      _acDetail.locationData.boundary_type_id = result.boundary_type_id
      _acDetail.locationData.latitude = result.latitude;
      _acDetail.locationData.longitude = result.longitude;
    }
    _acDetail.land_parcel.planning_status_id = this.landAreaSubject.value.planning_status_id
    _acDetail.land_parcel.ac_detail_land_area = this.landAreaComponentListSubject.value;
    _acDetail.land_parcel.land_cover_type = this.landUseSubject.value.land_cover_type;
    _acDetail.land_parcel.qos_degradation_id = this.landUseSubject.value.qos_degradation_id;
    _acDetail.land_parcel.comparative_land_use_id = this.landUseSubject.value.comparative_land_use_id;
    _acDetail.land_parcel.sol_use_classification_id = this.landUseSubject.value.sol_use_classification_id;
    _acDetail.land_parcel.other_characteristics = this.landUseSubject.value.other_characteristics;
    _acDetail.land_parcel.land_use_approval_implementation = this.landUseSubject.value.land_use_approval_implementation;
    _acDetail.land_parcel.building_exist = this.landUseSubject.value.building_exist;
    _acDetail.land_parcel.building_count = this.landUseSubject.value.building_count;
    _acDetail.land_parcel.description = this.landUseSubject.value.description;
    _acDetail.land_parcel.ac_detail_lp_buildings = this.buildingsSubject.value;

    _acDetail.ancillary_buildings = this._buildings$.getValue()

    return {
      ac: _acDetail,
      sizes,
      fileList,
      selectedFacilities: [],
      selectedFacilitiesOfficeExclusive: [],
      selectedFacilitiesOffice: [],
      externalAreas: [],
      ratings,
      participants,
      userId: this.currentUser.id,
      sizeModuleData,
      ipmsSizeData,
      codeOfMeasurementData
    };
  }

  /**
     * Create assignment
     *
     * @param _assetClassDetail: AssetClassDetailModel
     */
  createAssetClassDetail(
    _assetClassDetail: AssetClassDetailModel, {
      sizes,
      fileList,
      selectedFacilities,
      selectedFacilitiesOffice,
      selectedFacilitiesOfficeExclusive,
      externalAreas,
      ratings,
      participants,
      userId,
      sizeModuleData,
      ipmsSizeData,
      codeOfMeasurementData
    }) {
    this.store.dispatch(new AssetClassDetailOnServerCreated({
      assetClass: _assetClassDetail,
      sizes,
      fileList,
      selectedFacilities,
      selectedFacilitiesOffice,
      selectedFacilitiesOfficeExclusive,
      externalAreas,
      ratings,
      participants,
      userId,
      sizeModuleData,
      ipmsSizeData,
      codeOfMeasurementData
    }));

    this.componentSubscription = this.store.pipe(
      select(selectLastCreatedAssetClassDetailId),
      delay(1000), // Remove this line
    ).subscribe(res => {
      if (!res) {
        return;
      }
      this.saveState = true;
      this.navToList();
    });
  }

  /**
   * Update assignment
   *
   * @param _assetClassDetail: AssetClassDetailModel
   */
  updateAssetClassDetail(_assetClassDetail: AssetClassDetailModel, {
    sizes,
    fileList,
    selectedFacilities,
    selectedFacilitiesOffice,
    selectedFacilitiesOfficeExclusive,
    externalAreas,
    ratings,
    participants,
    userId,
    sizeModuleData,
    ipmsSizeData,
    codeOfMeasurementData
  }) {
    this.store.dispatch(new AssetClassDetailOnServerUpdated({
      assetClass: _assetClassDetail,
      sizes,
      fileList,
      selectedFacilities,
      selectedFacilitiesOffice,
      selectedFacilitiesOfficeExclusive,
      externalAreas,
      ratings,
      participants,
      userId,
      sizeModuleData,
      ipmsSizeData,
      codeOfMeasurementData
    }));
    this.saveState = true;
    this.navToList();
  }

  navToList() {
    //  http://192.168.244.150:8803/default/assignment/assignments/2/toes/1/dashboard
    //     http://192.168.244.150:8803/default/assignment/assignments/2/toes/1/inspection/7
    this.router.navigate(['../../', 'dashboard'], { relativeTo: this.activatedRoute });
  }

  onSubTypeCategoryChange(id: number) {
    if (id == 19 || id == 21) {
      this.showConditionRating = false;
      this.showBuilding = false;
    } else {
      this.showConditionRating = true;
      this.showBuilding = true;
    }
    this.showConditionRating$.next(this.showConditionRating);
  }

  onBuildingSelected(building: any) {
    this.building$.next(building)
  }

  erroTabMap() {
    return this.typesUtilsService.getInspectionTabErrorMap(this.error.fields, this.tabHeaders);
  }
  onHasFormErrorsChange(obj: { hasFormErrors: boolean }) {
    this.hasFormError = obj.hasFormErrors;
  }

  buildingPicChange({ pictures, picture }) {
    this.building_pictures = pictures;
    this.building_picture = picture;
  }

  onCenterChange(locationData) {
    this.centerLat = locationData.latitude;
    this.centerLng = locationData.longitude;
    this.assetClassDetail = Object.assign({}, this.assetClassDetail, {
      locationData: {
        ...this.assetClassDetail.locationData,
        latitude: (Number(locationData.latitude)),
        longitude: (Number(locationData.longitude)),
        address: locationData.address,
        location_grade_id: locationData.location_grade_id,
        zip_code: locationData.zip_code,
        city_id: locationData.city_id,
        location_surrounding: locationData.location_surrounding
      }
    });
  }

  onRoomChanged(event: Rooms) {
    this.roomChange$.next(event);
  }

  onChangeComponents(components: any[]) {
    this.ipmsComponents$.next(components);
  }

  onChangeStandardMeasurement(value: number) {
    this.standardMeasurementId = value
  }

  onLandSizesChange(value: number) {
  }

  handleLocationFormStateChange(event: { invalid: boolean | undefined, fields: number }) {
    const state = this._formState$.getValue()
    this._formState$.next({
      ...state,
      location: event
    })
  }

  handleAboutFormStateChange(event: boolean | undefined) {
    const state = this._formState$.getValue()
    this._formState$.next({
      ...state,
      property: {
        invalid: event,
        fields: 0
      }
    })
  }

  handleInternalAspect(event: boolean | undefined) {
    const state = this._formState$.getValue()
    this._formState$.next({
      ...state,
      internal_aspect: {
        invalid: event,
        fields: 0
      }
    })
  }

  handleExternalAspect(event: boolean | undefined) {
    const state = this._formState$.getValue()
    this._formState$.next({
      ...state,
      external_aspect: {
        invalid: event,
        fields: 0
      }
    })
  }

  handleGround(event: boolean | undefined) {
    const state = this._formState$.getValue()
    this._formState$.next({
      ...state,
      grounds: {
        invalid: event,
        fields: 0
      }
    })
  }

  private _updateState() {
    const state = this._formState$.getValue()
    this._formState$.next({
      ...state,
      pictures: {
        invalid: this.assetClassDetail.ac_pictures.length != 0 ? false : undefined,
        fields: 0
      },
      building_pictures: {
        invalid: this.building_pictures.length != 0 ? false : undefined,
        fields: 0
      }
    })
  }

  onBuildingChange(building: AncillaryBuilding) {
    const currentBuildings = this._buildings$.getValue()
    const buildings = currentBuildings.map(item => {
      if (item.uuid === building.uuid) return building
      return item
    })
    this._buildings$.next(buildings)
  }
  identity(index: number, item: { uuid: string }) {
    return item.uuid
  }

  onBuildingNumberChange(value: number) {
    const currentBuildings = this._buildings$.getValue()
    if (value < currentBuildings.length) {
      const buildings = currentBuildings.slice(0, value)
      this._buildings$.next(buildings)
      return;
    }
    if (value > currentBuildings.length) {
      const extra = Array.from({
        length: value - currentBuildings.length
      }, (_, i) => createAncillaryBuilding())
      const buildings = [...currentBuildings, ...extra]
      this._buildings$.next(buildings)
      return;
    }
  }

  onCoordinatePointsChange(points: CoordinatePoint[]) {
    this._coordinatePoints$.next(points)
  }
  onLandAreasChange(items: LandArea[]) {
    this._landAreas$.next(items)
  }
}

type FormState = {
  location: { invalid: boolean | undefined, fields: number },
  property: { invalid: boolean | undefined, fields: number },
  internal_aspect: { invalid: boolean | undefined, fields: number },
  external_aspect: { invalid: boolean | undefined, fields: number },
  grounds: { invalid: boolean | undefined, fields: number },
  pictures: { invalid: boolean | undefined, fields: number },
  building_pictures: { invalid: boolean | undefined, fields: number }
}

function locationTab(formState: FormState) {
  let _state = 'required'
  let _fields = 0

  if (formState.location.invalid) {
    _state = 'error'
    _fields = formState.location.fields
  } else if (formState.location.invalid === false) {
    _state = 'complete'
  }

  return {
    state: _state,
    requiredFields: _fields
  }
}

function propertyTab(formState: FormState) {
  let _state = 'required'
  let _fields = 0

  if (formState.property.invalid || formState.internal_aspect.invalid || formState.external_aspect.invalid || formState.grounds.invalid) {
    _state = 'error'
    _fields = formState.property.fields + formState.internal_aspect.fields + formState.external_aspect.fields + formState.grounds.fields
  } else if (formState.property.invalid === false && formState.internal_aspect.invalid === false && formState.external_aspect.invalid === false && formState.grounds.invalid === false) {
    _state = 'complete'
  }

  return {
    state: _state,
    requiredFields: _fields
  }
}

function esgTab(formState: FormState) {
  let _state = undefined
  let _fields = 0

  return {
    state: _state,
    requiredFields: _fields
  }
}

function conditionAssessmentTab(formState: FormState) {
  let _state = undefined
  let _fields = 0

  return {
    state: _state,
    requiredFields: _fields
  }
}

function picturesTab(formState: FormState) {
  let _state = 'required'
  let _fields = 0

  if (formState.pictures.invalid || formState.building_pictures.invalid) {
    _state = 'error'
    _fields = formState.pictures.fields + formState.building_pictures.fields
  } else if (formState.pictures.invalid === false && formState.building_pictures.invalid === false) {
    _state = 'complete'
  }

  return {
    state: _state,
    requiredFields: _fields
  }
}